























































































































































































































































































































































































import * as R from 'ramda';
import Vue from 'vue';
import {Decimal} from 'decimal.js';

import {GqlAuditor, GqlEntry, getEntry} from './graphql';

import PriceInput from '@/vue/components/input/Price.vue';

export default Vue.extend({
  components: {
    'input-price': PriceInput,
  },

  props: {
    auditor: {
      type: Object as () => GqlAuditor | null,
    },
    entryId: {
      type: String as () => string | null,
    },
    outletId: {
      type: String as () => string | null,
    },
    taskDate: {
      type: String as () => string,
      required: true,
    },
  },

  apollo: {
    entry: {
      query: getEntry,
      variables() {
        return {id: this.entryId, outletId: this.outletId};
      },
      skip() {
        return this.entryId === null;
      },
    },
  },

  data() {
    return {
      entry: null as GqlEntry | null,
      isEditing: false as boolean,
      currPrice: null as number | string | null,
    };
  },

  watch: {
    entry(obj) {
      this.currPrice = obj.currPrice;

      if (obj.currPrice !== null) {
        this.currPrice = (obj.currPrice / 100).toFixed(2);
      }
    }
  },

  computed: {
    auditorName(): string {
      return R.path(['name'], this.auditor) || 'Unassigned';
    },
    auditorPhoto(): string | null | undefined {
      return this.auditor ? R.path(['avatar', 'url'], this.auditor) : null;
    },
    isPromo(): boolean {
      if (!this.entry) {
        return false;
      }

      return this.entry.promoPrice !== null;
    },
    isPromoEnd(): boolean {
      if (!this.entry) {
        return false;
      }

      const tillDate = this.entry.promotionTill;
      if (tillDate && this.taskDate > tillDate) {
        return true;
      }

      return false;
    },
    isPromoInStore(): boolean {
      if (!this.entry) {
        return false;
      }

      return this.entry.isPromo || false;
    },
    isOos(): boolean {
      if (!this.entry) {
        return false;
      }

      return this.entry.isOos || false;
    },
    productPhoto(): string | null | undefined {
      return this.entry
          ? R.path(['product', 'photo', 'url'], this.entry)
          : null;
    },
  },

  filters: {
    as_price(val: number | null): string {
      if (val === null) {
        return '-';
      }

      return (val / 100).toFixed(2);
    },
  },

  methods: {
    onChangeOos() {
      if (!this.entry) {
        return false;
      }

      this.entry.isOos = ! this.entry.isOos;
    },
    onChangeInStorePromo() {
      if (!this.entry) {
        return false;
      }

      this.entry.isPromo = ! this.entry.isPromo;
    },
    handleViewPhotos() {
      this.$emit('view-attachment', this.entry!.id);
    },
    handleEdit() {
      this.isEditing = true;
    },
    handleSave() {
      this.isEditing = false;

      if (! this.entry) {
        return;
      }

      // @ts-ignore
      this.entry.currPrice = (new Decimal(this.currPrice)).times(100).toNumber();

      this.$emit('update', {
        id: this.entry!.id,
        currPrice: this.currPrice,
        noteAuditor: this.entry!.noteAuditor,
        isPromo: this.entry!.isPromo,
        isOos: this.entry!.isOos,
      });
    },
  },
});
